import React, { useState } from 'react'
import './RequestPayoutModal.css' // Optional: for styling
import ClipLoader from 'react-spinners/ClipLoader'

const FullPayoutModal = ({
  isOpen,
  onClose,
  onConfirm,
  netPayout,
  payOutType,
  clipLoading,
  confirmBtn,
  disabledBtn,
  source,
}) => {
  const [amount, setAmount] = useState('')
  if (!isOpen) return null

  const handleSubmit = () => {
    const numericAmount = payOutType === 'full' ? netPayout : parseFloat(amount)

    onConfirm(numericAmount)
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className={clipLoading ? 'd-none' : ''}>
          <label>
            <h5>Confirm {payOutType} payout</h5>
          </label>
          <p>You're about to request a {payOutType} payout for this event.</p>

          <div className="net-payout">
            <strong>Eligibile Earnings</strong> <span>R{netPayout.toFixed(2)}</span>
          </div>

          <div>
            <label>Enter amount</label>
            <input
              className="form-control"
              placeholder={`Amount may not exceed R${
                source === 'partnerPayout' ? Number(netPayout).toFixed(2) : netPayout
              }`}
              type="text"
              readOnly={payOutType === 'full' ? true : false}
              value={
                payOutType === 'partial'
                  ? amount
                  : source === 'partnerPayout'
                  ? Number(netPayout).toFixed(2)
                  : netPayout
              }
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>

          <p className={payOutType === 'partial' ? 'd-none' : 'note'}>
            {/* {source === 'partnerPayout'
              ? 'Eligible Earnings reflect revenue from ticket sales tied to events with locked refund policies. If refunds were allowed and any linked transactions are refunded, this amount may be adjusted to maintain payout integrity.'
              : 'This amount reflects your full earnings after all applicable deductions. Booking fees are buyer-funded and do not reduce your payout.'
            } */}

            {source === 'partnerPayout' ? (
              <div className="alert alert-info mt-2 p-2" role="alert">
                Affiliate Earnings reflect commissions from ticket sales, regardless of refund
                policies. Even if refunds are processed for linked transactions, your affiliate
                payouts remain unchanged to ensure consistency and trust.
              </div>
            ) : (
              <div className="alert alert-info mt-2 p-2" role="alert">
                This amount reflects your full earnings after all applicable deductions. Booking
                fees are buyer-funded and do not reduce your payout.
              </div>
            )}
          </p>

          <div className="modal-actions">
            <button className={confirmBtn} onClick={handleSubmit} disabled={disabledBtn}>
              Confirm Payout
            </button>
            <button className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
        <div className={!clipLoading ? 'd-none' : 'text-center text-grey'}>
          <ClipLoader size={25} color="grey" />
          <br />
          Submitting request...
        </div>
      </div>
    </div>
  )
}

export default FullPayoutModal
